module.exports = __webpack_public_path__ + "img/lawContrant3.073e6abc.png";